import React from 'react';

type Props = {
  width?: string,
  height?: string,
  stroke?: string,
  className: string,
}

const Home = ({ className, stroke, width, height }: Props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    version="1.1"
    viewBox="0 0 12.7 12.7"
    width={width}
    height={height}
    className={className}
    transform="scale(1.3)"
  >
    <g>
      <path
        fill="none"
        stroke={stroke}
        strokeDasharray="none"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        strokeOpacity="1"
        strokeWidth="0.529"
        d="M7.44 10.57h1.821V6.763l.704.007a.491.491 0 00.397-.787L9.012 4.2V2.569a.387.387 0 00-.383-.39.387.387 0 00-.384.39v.684a.239.239 0 01-.146.22.234.234 0 01-.256-.051L6.724 2.289a.556.556 0 00-.774 0L2.382 5.934a.491.491 0 00.356.834l.675-.006v3.294l.003.515h1.822V8.614c0-.547.44-.992.978-.992h.245c.54 0 .979.445.979.992v1.957z"
      />
    </g>
  </svg>
);

Home.defaultProps = {
  stroke: '#1a1818',
  height: '48',
  width: '48',
};

export default Home;
